// ─────────────────────────────────────────────────────────────────────────────
// pairingMemory.js — Remembers the most recently paired smart-gate vendor +
// rig so we can offer a one-tap "Use last device?" toast on the Monitor page
// instead of forcing the rower back into Settings every session.
//
// The actual BLE re-connect is delegated to a callback the Monitor page
// registers — pairingMemory itself is purely a localStorage cache.
// ─────────────────────────────────────────────────────────────────────────────

const KEY = 'crewz_last_paired_oarlock';
const TOAST_DISMISSED_KEY = 'crewz_last_paired_toast_dismissed';
const DISMISS_TTL_MS = 1000 * 60 * 60 * 12;  // 12h — show toast again after this

export function setLastPaired({ vendor, boatId, seatNumber, side, displayName } = {}) {
  if (!vendor) return;
  try {
    localStorage.setItem(KEY, JSON.stringify({
      vendor,
      boat_id: boatId || 'BOAT1',
      seat_number: Number(seatNumber) || 1,
      side: side || 'sweep',
      display_name: displayName || vendor,
      saved_at: Date.now(),
    }));
    window.dispatchEvent(new CustomEvent('crewz-last-paired-changed'));
  } catch (_e) { /* swallow */ }
}

export function getLastPaired() {
  try {
    const raw = localStorage.getItem(KEY);
    if (!raw) return null;
    return JSON.parse(raw);
  } catch { return null; }
}

export function clearLastPaired() {
  try {
    localStorage.removeItem(KEY);
    localStorage.removeItem(TOAST_DISMISSED_KEY);
  } catch (_e) { /* swallow */ }
}

/** Returns true if the user dismissed the toast recently (within TTL). */
export function isLastPairedToastDismissed() {
  try {
    const raw = localStorage.getItem(TOAST_DISMISSED_KEY);
    if (!raw) return false;
    const ts = parseInt(raw, 10);
    if (!Number.isFinite(ts)) return false;
    return Date.now() - ts < DISMISS_TTL_MS;
  } catch { return false; }
}

export function markLastPairedToastDismissed() {
  try {
    localStorage.setItem(TOAST_DISMISSED_KEY, String(Date.now()));
  } catch (_e) { /* swallow */ }
}
